import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor"

const PieChart = ({ dataColors, seriesValues }) => {
  const PieApexChartColors = getChartColorsArray(dataColors)

  const series = seriesValues
  const options = {
    chart: {
      height: 320,
      type: "pie",
    },
    series: series,
    labels: ["Active", "Alarm", "Failure Breathers"],
    colors: PieApexChartColors,
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  }

  return series[0] > 0 || series[1] > 0 || series[2] > 0 ? (
    <ReactApexChart options={options} series={series} type="pie" height="320" />
  ) : (
    "NO VALUE TO DISPLAY"
  )
}

export default PieChart
